<div class="container" [hidden]="loading">
  <div *ngIf="!showResendEmailBox" class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <form [formGroup]="addPhoneNumberForm" class="addPhoneNumberForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <p class="form-text-header">Add your phone number</p>
          <div class="d-flex align-items-center content">
            <mat-form-field>
              <mat-select [formControl]="countryCtrl" placeholder="Phone number" #singleSelect>
                <ngx-mat-select-search [placeholderLabel]="'Find calling code...'" [noEntriesFoundLabel]="'No matching calling code found'"
                  [formControl]="countryFilterCtrl"></ngx-mat-select-search>
                <mat-select-trigger *ngIf="countryCtrl.value">
                  <div class="d-flex align-items-center">
                    <img src="/assets/images/icon/down-arrow.svg" alt="down-arrow" class="down-arrow" />
                    <span class="{{countryCtrl.value.countryCode | flagIcon}}"></span>&nbsp;
                    <span>{{countryCtrl.value.code}}</span>
                  </div>
                </mat-select-trigger>
                <mat-option *ngFor="let country of (filteredCountries | async)" [value]="country">
                  <span [class]="country.countryCode | flagIcon"></span>&nbsp;
                  <span>{{ country.code }}</span>&nbsp;
                  <span>{{ country.countryName }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <input matInput placeholder="" maxlength="15" autofocus class="phone" type="text" class="input-phone-number" formControlName="phoneNumber"
              (keypress)="(($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode === 0)" />
          </div>
        </div>

        <p class="text-center text-description">
          For your security we use two factor authentication (2FA) to secure your account.
        </p>
        <div>
          <button class="btn btn-block" type="submit" [ngClass]="{
            'btn-greengo': addPhoneNumberForm.valid && countryCtrl.value,
            'btn-inactive': !addPhoneNumberForm.valid || !countryCtrl.value
          }" npFocusOutClicked>Send Code</button>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="showResendEmailBox" class="col-md-8 col-lg-6 mx-auto verifyEmailForm">
    <div class="form-group row">
      <h6 class="fill-nightfall mx-auto">Your verification link has expired</h6>
      <div class="col-12 text-center my-3 my-md-4">
        <img class="img-fluid img-verify-email" src="/assets/images/verify-email.png" alt="{{brandName}} Verify your email">
      </div>
    </div>
    <p class="fill-nightfall text-center mb-3 mb-md-5">
      Welcome to {{brandName}}!<br>
      The verification link for your contact email address
      <strong>{{ resendEmailInfo.email }}</strong> has expired. Please click the button below to receive a new email.
    </p>
    <div>
      <button class="btn btn-block btn-greengo" type="button" (click)="resendEmail()" npFocusOutClicked>Resend email</button>
    </div>
    <p class="footer">
      Go back to
      <a *ngIf="!isPrivalgoMarkets" routerLink="/auth/login" class="link">Privalgo.co.uk</a>
      <a *ngIf="isPrivalgoMarkets" routerLink="/auth/login" class="link">PrivalgoMarkets.co.uk</a>
    </p>
  </div>
</div>